define('modules/start/products/trans/status/model',['require','exports','module','app','env','base/model'],function(require, exports, module) {
    "use strict";

    var app = require("app");
    var Config = require("env");

    var BaseModel = require("base/model");

    var Model = BaseModel.extend({
        url: function() {
            var url = Config.backendUrl + "/details/mdirector";
            if (this.get('companyId')) {
                url += "/company/" + this.get('companyId');
            }
            return url;
        },
        initialize: function() {
            this.initRequestEvents();
        }
    });

    module.exports = Model;
});

